import gql from "graphql-tag";

export const catalogCategoriesQuery = gql`
  query catalogCategories($filters: CatalogCategoryListFilters, $page: Int, $perPage: Int) {
    catalogCategories(filters: $filters, page: $page, perPage: $perPage) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        name
        sort
        isActive
        parentId
        forNotice
        createdAt
        parent {
          id
          name
        }
      }
    }
  }
`;
